<template>
  <div class="newfooter">
    <div class="wrap">
      <div class="s1">
        <div class="slogo-title">RCEP.OTECHSOLUTION.COM</div>
        <div class="company">
          <div class="c1">公司地址</div>
          <div class="c2">上海市浦东新区盛夏路666号D栋904室</div>
        </div>
        <div class="tel">
          <div class="t1">联系电话</div>
          <div class="t2">400-099-9825</div>
        </div>
      </div>
      <div class="s2">
        <div class="qrcode">
          <div class="q1">
            <img src="~@/assets/images/home/q1.png" alt="">
            <p>科橘OTECH</p>
          </div>
          <div class="q2">
            <img src="~@/assets/images/home/q2.png" alt="">
            <p>大橘市二维码</p>
          </div>
        </div>
        <div class="links">
          <div class="title">友情链接</div>
          <ul>
            <li class="ellipsis" v-for="(item, index) in links" :key="`fl-${index}`">
              <a :href="item.url" target="_blank" class="line2">{{item.name || item.title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="beian">
      <img src="https://icon.cnzz.com/img/pic.gif" /> 
      
      <div class="s1">
        <span>Copyright © 上海科橘信息科技有限公司 </span>
        <a href="https://beian.miit.gov.cn/" target="_blank"> 沪ICP备19035327号-1</a>
         <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502009916" target="_blank"> 沪公网安备31011502009916号</a>
            <a href="https://www.yongsy.com/" target="_blank"> Powered by Yongsy</a>
            <span>|</span>
           <a href="https://www.otechsolution.com/PrivacyClause.html" target="_blank"> 隐私条款</a>
      </div>
      
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default {
  name: 'NewFooter1',
  computed: {
    ...mapDataState({
      links: state => state.links
    })
  }
}
</script>

<style scoped>
.newfooter{
  background: #194798;
  padding: 60px 0;
  color: #fff;
  padding-bottom: 20px;
}
.wrap{

  margin: 0 auto;
  width: 1400px;
  display: flex;
}
.s1{
  padding-right: 100px;
  border-right: 1px solid rgba(255,255,255,.35);
}
.slogo-title{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.company{
  margin-bottom: 30px;
}
.company .c1, .tel .t1{
  font-size: 18px;
  margin-bottom: 3px;
}
.company .c2, .tel .t2{
  font-size: 16px;
  line-height: 30px;
}
.s2{
  padding-left: 100px;
  display: flex;
}
.qrcode{
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 16px;
  margin-right: 80px;
  white-space: nowrap;
}
.qrcode .q1{
  margin-right: 60px;
  width: 100px;
}
.qrcode .q2{
  width: 100px;
}
.qrcode img{
  width: 100px;
  margin-bottom: 12px;
}
.links .title{
  font-size: 18px;
  margin-bottom: 10px;
}
.links li{
  margin-bottom: 6px;
}
.links li a{
  color: #fff;
  font-size: 16px;
}
.links li a:hover{
  text-decoration: underline;
}
.beian{
  /* background: #081f47; */
  text-align: center;
 margin-top: 20px;
  
}
.beian img{
  margin: 0 auto;
}
.beian a,.beian span{
color:#aba4a4
}

</style>


// WEBPACK FOOTER //
// src/components/layout/Footer1.vue